export const heroStats = [
  {
    icon: 'ri-customer-service-line',
    value: '+ 900',
    description: 'Soluções entregues em todo Brasil',
  },
  {
    icon: 'ri-team-line',
    value: '+ 6 Anos',
    description: 'De experiência no mercado',
  },
  {
    icon: 'ri-shield-check-line',
    value: '99,9%',
    description: 'Resolução das demandas no mesmo dia',
  },
  {
    icon: 'ri-customer-service-2-line',
    value: 'Atendimento',
    description: 'Especializado e suporte contínuo',
  },
];

export const services = [
  {
    icon: 'ri-computer-line',
    title: 'Computadores e Notebooks',
    description: 'Equipamentos de alta performance para sua empresa.',
  },
  {
    icon: 'ri-printer-line',
    title: 'Impressoras e Suprimentos',
    description: 'Impressoras, toners, cartuchos e suprimentos originais e compatíveis.',
  },
  {
    icon: 'ri-headphone-line',
    title: 'Periféricos e Acessórios',
    description: 'Teclados, mouses, monitores, headsets e muito mais.',
  },
  {
    icon: 'ri-archive-drawer-line',
    title: 'Equipamentos para Escritório',
    description: 'Soluções completas para o dia a dia do seu negócio.',
  },
  {
    icon: 'ri-server-line',
    title: 'Infraestrutura de TI',
    description: 'Servidores, storages, redes e soluções de conectividade.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Serviços Integrados',
    description: 'Manutenção, suporte técnico e consultoria especializada.',
  },
];

export const products = [
  {
    id: 1,
    name: 'Notebook Dell Inspiron',
    category: 'Notebooks',
    price: 'R$ 2.250,00',
    image: 'https://readdy.ai/api/search-image?query=Modern%20silver%20laptop%20notebook%20computer%20on%20clean%20white%20background%2C%20product%20photography%2C%20professional%20studio%20lighting%2C%20high%20detail%2C%20minimalist%20style&width=400&height=300&seq=donnos-prod-01&orientation=landscape',
    tag: 'Mais Vendido',
  },
  {
    id: 2,
    name: 'Impressora HP LaserJet',
    category: 'Impressoras',
    price: 'R$ 1.200,00',
    image: 'https://readdy.ai/api/search-image?query=Modern%20black%20office%20laser%20printer%20on%20clean%20white%20background%2C%20product%20photography%2C%20professional%20studio%20lighting%2C%20high%20detail%2C%20minimalist%20style&width=400&height=300&seq=donnos-prod-02&orientation=landscape',
  },
  {
    id: 3,
    name: 'Monitor LG 22" Full HD',
    category: 'Monitores',
    price: 'R$ 550,00',
    image: 'https://readdy.ai/api/search-image?query=Modern%20computer%20monitor%20display%20screen%20on%20clean%20white%20background%2C%20product%20photography%2C%20professional%20studio%20lighting%2C%20high%20detail%2C%20minimalist%20style&width=400&height=300&seq=donnos-prod-03&orientation=landscape',
  },
  {
    id: 4,
    name: 'Teclado Qwerty Mecânico',
    category: 'Periféricos',
    price: 'R$ 95,00',
    image: 'https://readdy.ai/api/search-image?query=Mechanical%20keyboard%20qwerty%20layout%20on%20clean%20white%20background%2C%20product%20photography%2C%20professional%20studio%20lighting%2C%20high%20detail%2C%20minimalist%20style&width=400&height=300&seq=donnos-prod-04&orientation=landscape',
  },
  {
    id: 5,
    name: 'Computador Intel Core i5',
    category: 'Computadores',
    price: 'R$ 2.490,00',
    image: 'https://readdy.ai/api/search-image?query=Desktop%20computer%20tower%20PC%20case%20on%20clean%20white%20background%2C%20product%20photography%2C%20professional%20studio%20lighting%2C%20high%20detail%2C%20minimalist%20style&width=400&height=300&seq=donnos-prod-05&orientation=landscape',
  },
  {
    id: 6,
    name: 'Nobreak APC 600VA',
    category: 'Nobreaks',
    price: 'R$ 350,00',
    image: 'https://readdy.ai/api/search-image?query=UPS%20uninterruptible%20power%20supply%20unit%20on%20clean%20white%20background%2C%20product%20photography%2C%20professional%20studio%20lighting%2C%20high%20detail%2C%20minimalist%20style&width=400&height=300&seq=donnos-prod-06&orientation=landscape',
  },
];

export const publicServiceFeatures = [
  'Atendimento exclusivo para órgãos públicos',
  'Produtos dentro das normas de licitação',
  'Preços competitivos e transparentes',
  'Entrega em todo o território nacional',
  'Suporte técnico especializado',
  'Garantia em todos os produtos',
];

export const publicServiceCards = [
  {
    icon: 'ri-government-line',
    title: 'Compras Públicas',
    description: 'Atendimento especializado para licitações e compras de órgãos públicos, com produtos regulamentados e preços competitivos.',
  },
  {
    icon: 'ri-building-4-line',
    title: 'Compras Corporativas',
    description: 'Soluções completas para empresas privadas, desde pequenas startups até grandes corporações.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Consulta de Atas',
    description: 'Acesse nossas atas de registro de preços e encontre as melhores condições para sua instituição.',
    cta: 'Consultar agora',
  },
];

export const commitments = [
  {
    icon: 'ri-shield-star-line',
    title: 'Qualidade de Produtos',
    description: 'Oferecemos apenas produtos de marcas renomadas e com garantia oficial.',
  },
  {
    icon: 'ri-award-line',
    title: 'Produtos Originais',
    description: 'Toda nossa mercadoria é 100% original, com nota fiscal e garantia do fabricante.',
  },
  {
    icon: 'ri-customer-service-line',
    title: 'Suporte ao Cliente',
    description: 'Equipe especializada pronta para ajudar em todas as etapas da compra.',
  },
  {
    icon: 'ri-truck-line',
    title: 'Logística Eficiente',
    description: 'Entrega rápida e segura para todo o Brasil, com rastreamento em tempo real.',
  },
  {
    icon: 'ri-file-shield-line',
    title: 'Garantia e Segurança',
    description: 'Garantia em todos os produtos e processo de compra 100% seguro.',
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'Compromisso Social',
    description: 'Atuamos com responsabilidade social e ambiental em todas as nossas operações.',
  },
];

export const clientLogos = [
  { name: 'Brasil', icon: 'ri-government-line' },
  { name: 'Correios', icon: 'ri-mail-send-line' },
  { name: 'CREA-BA', icon: 'ri-building-line' },
  { name: 'BRB', icon: 'ri-bank-line' },
  { name: 'SEGER', icon: 'ri-organization-chart' },
  { name: 'TCU', icon: 'ri-scales-3-line' },
  { name: 'TST', icon: 'ri-graduation-cap-line' },
];

export const brandLogos = [
  { name: 'Dell', icon: 'ri-computer-line' },
  { name: 'Intel', icon: 'ri-cpu-line' },
  { name: 'Lenovo', icon: 'ri-device-line' },
  { name: 'Epson', icon: 'ri-printer-line' },
  { name: 'LogiLink', icon: 'ri-mouse-line' },
  { name: 'Microsoft', icon: 'ri-windows-line' },
];

export const navLinks = [
  { label: 'Início', href: '#inicio' },
  { label: 'Sobre', href: '#sobre' },
  { label: 'Soluções', href: '#solucoes', hasDropdown: true },
  { label: 'Produtos', href: '/produtos' },
  { label: 'Licitações', href: '#licitacoes' },
  { label: 'Consulta de Atas', href: '/atas' },
  { label: 'Contato', href: '#contato' },
];

export const footerLinks = {
  empresa: [
    { label: 'Sobre nós', href: '#sobre' },
    { label: 'Nossa história', href: '#sobre' },
  ],
  servicos: [
    { label: 'Produtos', href: '/produtos' },
    { label: 'Licitações', href: '#licitacoes' },
    { label: 'Consulta de Atas', href: '/atas' },
  ],
  suporte: [
    { label: 'Central de Ajuda', href: '#' },
    { label: 'Política de Privacidade', href: '#' },
    { label: 'Termos de Uso', href: '#' },
    { label: 'FAQ', href: '#' },
  ],
};
